const desktopNavMenus = () => {
  const body = document.querySelector('body');

  const getSubnavTrigger = (subnav) => {
    const trigger = subnav.firstElementChild;
    if (trigger && (trigger.tagName === 'BUTTON' || trigger.tagName === 'A')) {
      return trigger;
    }
    return null;
  };

  const closeAllMenus = () => {
    // Remove page overlay
    body.classList.remove('nav-menu-dropdown');
    const subnavDivs = document.querySelectorAll('.primary-nav-links .subnav, .eyebrow-nav .subnav');
    // Set default content for each menu
    for (let i = 0; i < subnavDivs.length; i++) { /* eslint-disable-line no-plusplus */
      subnavDivs[i].classList.remove('is-active');
      const trigger = getSubnavTrigger(subnavDivs[i]);
      if (trigger !== null) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    }
  };

  const closeMenuOnBodyClick = (event) => {
    if (event.target.closest('.subnav') === null) {
      closeAllMenus();
      document.querySelector('body').removeEventListener('click', closeMenuOnBodyClick);
    }
  };

  const disableForMyAccoount = (menuItem) => {
    const { isAuthenticated } = window;
    return menuItem.parentNode.classList.contains('icon-item-my-account') && !isAuthenticated;
  };


  const onMenuItemMouseEnter = (menuItem) => {
    closeAllMenus();
    if (disableForMyAccoount(menuItem)) {
      return;
    }
    menuItem.parentNode.classList.add('is-active');
    menuItem.setAttribute('aria-expanded', 'true');
    body.addEventListener('click', closeMenuOnBodyClick);
    body.classList.add('nav-menu-dropdown');
  };

  const onMenuItemMouseLeave = (menuItem) => {
    document.activeElement.blur();
    if (disableForMyAccoount(menuItem)) {
      return;
    }
    menuItem.parentNode.classList.remove('is-active');
    menuItem.setAttribute('aria-expanded', 'false');
    body.removeEventListener('click', closeMenuOnBodyClick);
    body.classList.remove('nav-menu-dropdown');
  };

  const onMenuItemClick = (menuItem) => {
    if (disableForMyAccoount(menuItem)) {
      return;
    }
    if (menuItem.parentNode.classList.contains('is-active')) {
      menuItem.parentNode.classList.remove('is-active');
      menuItem.setAttribute('aria-expanded', 'false');
      body.removeEventListener('click', closeMenuOnBodyClick);
      body.classList.remove('nav-menu-dropdown');
    } else {
      closeAllMenus();
      menuItem.parentNode.classList.add('is-active');
      menuItem.setAttribute('aria-expanded', 'true');
      body.addEventListener('click', closeMenuOnBodyClick);
      body.classList.add('nav-menu-dropdown');
    }
  };

  let collectedEvents = [];

  const selectEventHandler = () => {
    setTimeout(() => {
      // If click present, route to click event
      let active = collectedEvents.find(item => item.type === 'click');
      if (active) {
        active.callback(active.menuItem);
      } else {
        // Otherwise, use last event in array
        active = collectedEvents[collectedEvents.length - 1];
        if (active.type === 'mouseenter') {
          active.callback(active.menuItem);
        } else if (active.type === 'mouseleave') {
          active.callback(active.menuItem);
        }
      }
      // Otherwise chose last event handler in list
      collectedEvents = [];
    }, 100);
  };

  const manageMenuEvents = (menuItem, type, callback) => {
    if (collectedEvents.length === 0) {
      selectEventHandler();
    }
    collectedEvents.push({
      type,
      menuItem,
      callback,
    });
  };

  // Buttons toggle the menu on click. Linked items (primary nav and logged-in
  // account icon) navigate on click, so only hover opens/closes their dropdown.
  const hoverTriggers = '.subnav > button, .subnav > a.primary-nav-item, .eyebrow-nav .subnav > a.icon-nav-item';
  [].map.call(document.querySelectorAll('.subnav > button'), menuItem => (
    menuItem.addEventListener('click', (event) => {
      manageMenuEvents(menuItem, event.type, onMenuItemClick);
    })
  ));
  [].map.call(document.querySelectorAll(hoverTriggers), menuItem => (
    menuItem.parentNode.addEventListener('mouseenter', (event) => {
      manageMenuEvents(menuItem, event.type, onMenuItemMouseEnter);
    })
  ));
  [].map.call(document.querySelectorAll(hoverTriggers), menuItem => (
    menuItem.parentNode.addEventListener('mouseleave', (event) => {
      manageMenuEvents(menuItem, event.type, onMenuItemMouseLeave);
    })
  ));
  [].map.call(document.querySelectorAll('.primary-nav-links .dd-nav, .eyebrow-nav .dd-nav'), dropdown => (
    dropdown.addEventListener('mouseleave', () => {
      closeAllMenus();
      body.removeEventListener('click', closeMenuOnBodyClick);
      body.classList.remove('nav-menu-dropdown');
    })
  ));
  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') {
      closeAllMenus();
    }
  });
};

export default desktopNavMenus;
